import { selectUpcomingPickemDetails } from "selectors/PickemDetails";
import { EmptyGrowPanelText } from "styles/text";
import { UpcomingPickemOption } from "./UpcomingPickemOption";
import { useAppSelector } from "app/hooks";
import { shallowEqual } from "react-redux";
import { PanelList } from "components/PanelList/PanelList";

const MINIMUM_SHOWN_UPCOMING = 4;
const ALWAYS_SHOW_THRESHOLD = 1209600000;

export const UpcomingPickems = () => {
  const upcomingPickemDetails = useAppSelector(
    (state) =>
      selectUpcomingPickemDetails(
        state,
        ALWAYS_SHOW_THRESHOLD,
        MINIMUM_SHOWN_UPCOMING
      ),
    shallowEqual
  );

  if (upcomingPickemDetails.length === 0) {
    return <EmptyGrowPanelText>No Upcoming Pick'ems</EmptyGrowPanelText>;
  }

  return (
    <PanelList childHover={false}>
      {upcomingPickemDetails.map(
        ({ pickemId, tournamentId, name, openTime }) => {
          return (
            <UpcomingPickemOption
              key={`${tournamentId} - ${pickemId}`}
              tournamentId={tournamentId}
              name={name}
              openTime={openTime}
            />
          );
        }
      )}
    </PanelList>
  );
};
